import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppliedCouponsComponent } from '@spartacus/cart/base/components';

@Component({
  selector: 'cx-applied-coupons',
  templateUrl: './applied-coupons.component.html',
  styleUrl: './applied-coupons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomAppliedCouponsComponent extends AppliedCouponsComponent {
  @Input() coupons: string[] = [];
}
